export default {
  OVERDUE_REMINDER_TAG: 'maindata/indexOrder/getHeaderWMRemind', //逾期提醒tag
  FINANCE_SALES_INVOICE: 'financial/financialWarning/getFinanceSalesInvoice', //未开票预警
  FUND_COLLECTION: 'financial/financialWarning/getFundCollection', //未收款预警
  PAYABLE_SETTLEMENT_EXPENSE: 'financial/financialWarning/getPayableSettlementExpense', //应付费用预警
  RECEIVABLE_SETTLEMENT_EXPENSE: 'financial/financialWarning/getReceivableSettlementExpense', //应收费用预警
  COMPLETE_PAYMENT: 'financial/paymentApply/incompletePayment', //部分付款
  OVERDUE_REMINDER: 'financial/paymentApply/overdueReminder', //待付款
  RETURN_TICKET: 'financial/paymentApply/returnTicket', //回票
  WM_WAIT_DELIVER: 'sales/salesWarning/getWmWaitDeliverByPage', //代发货
  WM_WAIT_CARRY: 'warehouse/warehouseWarning/getWmWaitCarryByPage', //待提货
};
